import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mediaContainer", "currentIndex", "totalCount"]
  static values = { 
    mediaItems: Array,
    currentIndex: Number
  }

  connect() {
    console.log("Image viewer modal controller connected")
    this.setupEventListeners()
    this.showCurrentItem()
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener('keydown', this.handleKeydown.bind(this))
  }

  setupEventListeners() {
    // Keyboard navigation
    document.addEventListener('keydown', this.handleKeydown.bind(this))
    
    // Touch events for swipe navigation
    this.touchStartX = 0
    this.touchEndX = 0
    this.minSwipeDistance = 50
    this.isDragging = false

    this.mediaContainerTarget.addEventListener('touchstart', (e) => {
      if (e.target.closest('[data-action*="close"]')) return
      this.touchStartX = e.touches[0].clientX
      this.isDragging = true
    }, { passive: true })

    this.mediaContainerTarget.addEventListener('touchmove', (e) => {
      if (e.target.closest('[data-action*="close"]') || !this.isDragging) return
      this.touchEndX = e.touches[0].clientX
      const swipeDistance = this.touchEndX - this.touchStartX
      this.mediaContainerTarget.style.transform = `translateX(${swipeDistance * 0.5}px)`
    }, { passive: true })

    this.mediaContainerTarget.addEventListener('touchend', () => {
      if (!this.isDragging) return
      this.isDragging = false
      this.handleSwipeEnd()
    })
  }

  handleKeydown(e) {
    switch(e.key) {
      case 'ArrowLeft':
        this.showPrevious()
        break
      case 'ArrowRight':
        this.showNext()
        break
      case 'Escape':
        this.close()
        break
    }
  }

  handleSwipeEnd() {
    const swipeDistance = this.touchEndX - this.touchStartX
    
    if (Math.abs(swipeDistance) > this.minSwipeDistance) {
      if (swipeDistance > 0) {
        this.showPrevious()
      } else {
        this.showNext()
      }
    }
    
    // Reset transform
    this.mediaContainerTarget.style.transform = ''
  }

  showPrevious() {
    if (this.currentIndexValue > 0) {
      this.currentIndexValue--
      this.showCurrentItem()
    }
  }

  showNext() {
    if (this.currentIndexValue < this.mediaItemsValue.length - 1) {
      this.currentIndexValue++
      this.showCurrentItem()
    }
  }

  showCurrentItem() {
    const currentItem = this.mediaItemsValue[this.currentIndexValue]
    const img = this.mediaContainerTarget.querySelector('img')
    const video = this.mediaContainerTarget.querySelector('video')
    const prevButton = this.element.querySelector('[data-action*="showPrevious"]')
    const nextButton = this.element.querySelector('[data-action*="showNext"]')

    console.log('showCurrentItem called - currentItem:', currentItem, 'index:', this.currentIndexValue)

    // Reset any transform that might be left from dragging
    this.mediaContainerTarget.style.transform = ''

    // Hide both elements initially
    img.style.display = 'none'
    video.style.display = 'none'

    if (currentItem.media_type === 'image') {
      // Show image
      img.style.display = 'block'
      img.style.opacity = '0'
      setTimeout(() => {
        img.src = currentItem.file_url
        img.alt = currentItem.title
        img.style.opacity = '1'
      }, 200)
    } else if (currentItem.media_type === 'video') {
      // Show video
      video.style.display = 'block'
      video.src = currentItem.file_url
      video.load() // Force video to load new source
    }

    // Update counter
    this.currentIndexTarget.textContent = this.currentIndexValue + 1
    this.totalCountTarget.textContent = this.mediaItemsValue.length

    // Update navigation buttons
    prevButton.style.visibility = this.currentIndexValue === 0 ? 'hidden' : 'visible'
    nextButton.style.visibility = this.currentIndexValue === this.mediaItemsValue.length - 1 ? 'hidden' : 'visible'

    console.log('Media updated to:', currentItem.file_url, 'type:', currentItem.media_type)

    // Update the current media item in the dropdown controller
    const dropdownController = this.element.querySelector('[data-controller*="favourite-folder-dropdown"]')
    if (dropdownController) {
      const controller = this.application.getControllerForElementAndIdentifier(dropdownController, 'favourite-folder-dropdown')
      if (controller) {
        controller.currentMediaItemValue = currentItem
      }
    }
  }

  close() {
    this.element.remove()
  }
} 